import templateUrl from "emun.order/parts/parts-entry-grid.htm";
import controller from "emun.order/parts/parts-entry-grid.controller";

export default {
  bindings: {
    results: "=?",
    parts: "<",
    product: "<",
    mode: "@",
    imageSize: "@",
    defaultMinimum: "<"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
